import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { track } from "@/lib/api";
import { PROFILE_FIELDS } from "@/lib/options";
import { Button, ScreenHeader } from "@/components/kit";
import { Page } from "@/components/layout";
import { ProfileEditor } from "@/components/widgets";
import { useApp } from "@/store";

export default function EditProfile() {
  const [params] = useSearchParams();
  const next = params.get("next");
  const { profile, saveProfile, toast } = useApp();
  const [draft, setDraft] = useState({ ...profile });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const save = async () => {
    setSaving(true);
    try {
      await saveProfile({ ...draft, source: draft.source ?? "manual" });
      track("manual_profile");
      toast("Hair profile saved.", "success");
      if (next === "recs") navigate("/recommendations", { replace: true });
      else navigate(-1);
    } catch (e) {
      toast(e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="edit-profile-screen">
      <ScreenHeader testId="edit-profile-back" label="Hair profile" fallback="/mystyle" />
      <Page className="flex flex-col gap-6 pb-32">
        <div className="flex flex-col gap-2">
          <h1 data-testid="edit-profile-title" className="t-h1">{next === "recs" ? "ENTER YOUR DETAILS." : "EDIT YOUR PROFILE."}</h1>
          <p className="t-body">Everything is optional. Pick what you know — skip what you don&apos;t. Tap a selected option again to clear it.</p>
        </div>
        <ProfileEditor profile={draft} onChange={setDraft} fields={PROFILE_FIELDS} />
      </Page>
      <div className="fixed inset-x-0 bottom-0 z-30 border-t border-divider bg-off/95 py-3 backdrop-blur">
        <Page>
          <Button testId="edit-profile-save" title={next === "recs" ? "Save & see my styles" : "Save profile"} loading={saving} onClick={save} className="w-full" />
        </Page>
      </div>
    </div>
  );
}
